/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BotIntegrations,
  ConnectIntegrationRequest,
  DeleteIntegrationRequest,
  ToggleIntegrationRequest,
  UpdateIntegrationRequest,
} from '../models';

export interface ConnectIntegrationOperationRequest {
    connectIntegrationRequest: ConnectIntegrationRequest;
}

export interface DeleteIntegrationOperationRequest {
    deleteIntegrationRequest: DeleteIntegrationRequest;
}

export interface GetBotIntegrationsRequest {
    publicId: string;
}

export interface ToggleIntegrationOperationRequest {
    toggleIntegrationRequest: ToggleIntegrationRequest;
}

export interface UpdateIntegrationOperationRequest {
    updateIntegrationRequest: UpdateIntegrationRequest;
}

/**
 * 
 */
export class IntegrationControllerApi extends runtime.BaseAPI {

    /**
     */
    async connectIntegrationRaw(requestParameters: ConnectIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotIntegrations>> {
        if (requestParameters['connectIntegrationRequest'] == null) {
            throw new runtime.RequiredError(
                'connectIntegrationRequest',
                'Required parameter "connectIntegrationRequest" was null or undefined when calling connectIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/integration/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['connectIntegrationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async connectIntegration(requestParameters: ConnectIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotIntegrations> {
        const response = await this.connectIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteIntegrationRaw(requestParameters: DeleteIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotIntegrations>> {
        if (requestParameters['deleteIntegrationRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteIntegrationRequest',
                'Required parameter "deleteIntegrationRequest" was null or undefined when calling deleteIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/integration/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['deleteIntegrationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteIntegration(requestParameters: DeleteIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotIntegrations> {
        const response = await this.deleteIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotIntegrationsRaw(requestParameters: GetBotIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotIntegrations>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getBotIntegrations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/integration/bot/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotIntegrations(requestParameters: GetBotIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotIntegrations> {
        const response = await this.getBotIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async toggleIntegrationRaw(requestParameters: ToggleIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotIntegrations>> {
        if (requestParameters['toggleIntegrationRequest'] == null) {
            throw new runtime.RequiredError(
                'toggleIntegrationRequest',
                'Required parameter "toggleIntegrationRequest" was null or undefined when calling toggleIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/integration/toggle`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['toggleIntegrationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async toggleIntegration(requestParameters: ToggleIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotIntegrations> {
        const response = await this.toggleIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateIntegrationRaw(requestParameters: UpdateIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotIntegrations>> {
        if (requestParameters['updateIntegrationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIntegrationRequest',
                'Required parameter "updateIntegrationRequest" was null or undefined when calling updateIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/integration/update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateIntegrationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateIntegration(requestParameters: UpdateIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotIntegrations> {
        const response = await this.updateIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
